let promise = null as Promise<typeof window.YT.Player> | null;

export const loadYoutube = function (): Promise<typeof window.YT.Player> {
	if (promise) {
		return promise;
	}

	promise = new Promise<typeof window.YT.Player>((resolve, reject) => {
		window.onYouTubeIframeAPIReady = () => {
			return resolve(window.YT.Player);
		};

		try {
			const script = document.createElement('script');
			script.src = 'https://www.youtube.com/iframe_api';
			script.onerror = () => reject(`Failed to load script: ${script.src}`);
			document.head.appendChild(script);
		} catch (error) {
			reject(`Error loading YouTube Iframe API: ${error}`);
		}
	});

	return promise;
};
